var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinEmprestimoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    enableBackground: "new 0 0 19 19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x5F_ref",
    display: "none"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 -0.0031 0.0031 1 0.04 19.1113)",
    display: "inline",
    fill: "#61ABAC",
    fontFamily: "'cs-icons'",
    fontSize: 19.3298
  }, "6"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Emprestimo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.587,10.182l-2.831,0.01c0.105,1.838-0.175,4.431-0.845,7.779l-0.074,0.303L4.341,18.305l-0.076-0.264 c-0.633-1.257-0.952-2.729-0.957-4.415l-0.011-3.397L0.88,10.236L0.851,0.571l17.708-0.055L18.587,10.182z M3.294,9.436 L3.289,7.435C3.312,7.032,3.513,6.723,3.89,6.508c0.377-0.215,0.83-0.323,1.358-0.325c0.503,0.023,0.9,0.148,1.19,0.374 s0.436,0.516,0.437,0.867l0.006,2.001l2.454-0.008L9.331,8.021C8.727,7.946,8.197,7.772,7.744,7.496L8.269,6.59 c0.529,0.3,1.033,0.449,1.512,0.448h0.075c0.58-0.002,0.869-0.192,0.869-0.569c-0.002-0.277-0.316-0.503-0.947-0.677 C9.475,5.717,9.292,5.667,9.229,5.643C9.166,5.618,9.002,5.555,8.737,5.455c-0.264-0.1-0.435-0.2-0.51-0.3 c-0.076-0.1-0.165-0.246-0.266-0.434S7.809,4.325,7.809,4.099C7.807,3.722,7.944,3.388,8.221,3.098 c0.275-0.29,0.64-0.475,1.093-0.552l-0.003-1.17L1.646,1.399L1.671,9.44L3.294,9.436z M10.529,17.152 c-0.002-0.729-0.144-1.37-0.422-1.924c-0.278-0.553-0.602-0.967-0.966-1.242c-0.366-0.275-0.763-0.502-1.191-0.676 c-0.429-0.176-0.756-0.281-0.982-0.318c-0.227-0.037-0.391-0.057-0.491-0.057l-0.378,0.002l-0.001-0.377L6.082,7.426 C6.081,7.15,5.791,7.012,5.212,7.014C4.935,6.99,4.684,7.028,4.458,7.13c-0.227,0.1-0.353,0.215-0.376,0.341l0.019,6.153 c0.004,1.259,0.272,2.542,0.804,3.849l5.625-0.017V17.152z M14.963,10.193l-8.08,0.023l0.006,2.001 c0.402,0.074,0.806,0.187,1.209,0.337c0.403,0.149,0.87,0.394,1.399,0.731c0.53,0.338,0.966,0.841,1.308,1.506 c0.342,0.666,0.514,1.452,0.518,2.356l0.001,0.304l2.868-0.009C14.812,14.799,15.07,12.382,14.963,10.193z M17.768,1.351 l-7.664,0.023l0.004,1.17c0.554,0.023,1.096,0.16,1.625,0.41L11.32,3.861c-0.506-0.225-0.996-0.337-1.474-0.335H9.77 C9.292,3.578,9.054,3.768,9.055,4.095c0,0.227,0.24,0.428,0.719,0.603c0.025,0,0.151,0.03,0.376,0.093 c0.229,0.062,0.373,0.105,0.436,0.131c0.062,0.026,0.189,0.069,0.378,0.131s0.322,0.131,0.397,0.207 c0.076,0.075,0.17,0.169,0.283,0.282c0.113,0.112,0.189,0.244,0.229,0.395c0.038,0.151,0.059,0.315,0.059,0.491 c0.004,0.981-0.6,1.525-1.808,1.629l0.004,1.359l7.664-0.023L17.768,1.351z",
    fill: "currentColor"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Viagem",
    display: "none"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 -0.0031 0.0031 1 0.04 19.1113)",
    display: "inline",
    fill: "#61ABAC",
    fontFamily: "'cs-icons'",
    fontSize: 19.3298
  }, "6"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinEmprestimoIcon);
export default __webpack_public_path__ + "static/media/zeppelin-emprestimo-icon.d8b695ff.svg";
export { ForwardRef as ReactComponent };